<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card title="RETURN FINISHED PRODUCT STOCK">
          <div slot="no-body" class="mt-4"  v-can="'view-product-stock-inventory'">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table
              id="finish-product-stock-list-table"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="items"
              sort
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="20%"  class="text-xs">FORMULATION CODE</vs-th>
                <vs-th width="20%"  class="text-xs">ORDER CODE</vs-th>
                <vs-th width="20%"  class="text-xs">WO ORDER CODE</vs-th>
                <vs-th width="15%" class="text-xs">RETURN QUANTITY (KG)</vs-th>
                <vs-th width="15%" class="text-xs">RETURN STOCK STATUS</vs-th>
                <vs-th  v-can="'edit-product-stock-inventory'" width="15%" class="text-xs">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                   <vs-td :data="data[indextr].formulation_code">
                    <HyperLink :id="data[indextr].formulation_id" type="formulation">
                      {{ data[indextr].formulation_code}}
                    </HyperLink>
                  </vs-td>

                  <vs-td :data="data[indextr].order_code">
                    <HyperLink :id="data[indextr].order_id" type="product-order">{{ data[indextr].order_code}}</HyperLink>
                  </vs-td>

                  <vs-td :data="data[indextr].work_order">
                    <HyperLink :id="data[indextr].work_order_id" type="work-order">{{ data[indextr].work_order}}</HyperLink>
                  </vs-td>

                  <vs-td class="font-bold" :data="data[indextr].quantity">
                    {{ Number(data[indextr].quantity).toFixed(4) }}
                  </vs-td>

                  <vs-td :data="data[indextr].status">
                    {{ data[indextr].status }}
                  </vs-td>

                  <vs-td v-can="'edit-product-stock-inventory'">
                    <!-- <div class="vx-row">
                      <vx-tooltip text="Adjust Stock" position="left">
                        <vs-button class="ml-3"
                                   @click.STOP="onClickStockChange(data[indextr])"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                    </div> -->
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>

  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const InventoryRepository = RepositoryFactory.get('inventory')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";

  export default {
    name: 'ReturnProductStockList',
    data () {
      return {
        items: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    methods: {
      async refreshData () {
        this.fetchProductStockList()
      },
      async fetchProductStockList() {
        await this.$vs.loading({
          container: '#finish-product-stock-list-table',
          scale: 0.45
        })
        try {
          const {data} = await InventoryRepository.getListOfProductReturnStock(this.page, this.filterQuery, this.perPage)
          this.items =  data.data
          this.meta = data.meta
        } catch (e) {

          this.showWarningMessage('Something went wrong. Please try again!')
        }
        this.$vs.loading.close('#finish-product-stock-list-table > .con-vs-loading')
      },

      filterQueryUpdate (){
        this.fetchProductStockList()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchProductStockList()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchProductStockList()
        }

      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },

      onClickStockChange(data) {
      },
    },
    watch : {
      page(){
        this.fetchProductStockList()
      },
      perPage() {
        this.fetchProductStockList()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
